import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import CommentSection from "./CommentSection";
import "./Service3Payment.css";

import paypalLogo from "../assets/paypal.png";
import visaLogo from "../assets/visa.png";
import mastercardLogo from "../assets/mastercard.png";

const Service3Payment = () => {
  const [selectedMethod, setSelectedMethod] = useState("");
  const [amount] = useState("150"); // Example — auto-filled from location selection

  const handlePayment = () => {
    if (!selectedMethod) {
      alert("Please select a payment method.");
      return;
    }
    alert(`Redirecting to ${selectedMethod} payment gateway for $${amount}`);
  };

  return (
    <>
      
      <section className="payment-section">
        <h2>Secure Payment</h2>
        <p>Pay for your bird photography session safely using any of the methods below.</p>

        <div className="payment-methods">
          <div
            className={`payment-card ${selectedMethod === "PayPal" ? "selected" : ""}`}
            onClick={() => setSelectedMethod("PayPal")}
          >
            <img src={paypalLogo} alt="PayPal" />
            <p>PayPal</p>
          </div>

          <div
            className={`payment-card ${selectedMethod === "Visa" ? "selected" : ""}`}
            onClick={() => setSelectedMethod("Visa")}
          >
            <img src={visaLogo} alt="Visa" />
            <p>Visa</p>
          </div>

          <div
            className={`payment-card ${selectedMethod === "Mastercard" ? "selected" : ""}`}
            onClick={() => setSelectedMethod("Mastercard")}
          >
            <img src={mastercardLogo} alt="Mastercard" />
            <p>Mastercard</p>
          </div>
        </div>

        <div className="amount-display">
          <h3>Total Amount: <span>${amount}</span></h3>
          <button className="pay-btn" onClick={handlePayment}>Proceed to Pay</button>
        </div>
      </section>

      <CommentSection />
    
    </>
  );
};

export default Service3Payment;
